import {createContext} from 'react';

export const AnswersContext = createContext(null);
